/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
// import Vue from 'vue'
import Vue from 'vue'
// import { modalBus } from '../../../main'
import { checkTokenValidity, checkTokenExpiry } from '@/helpers/token'
import store from '@/store'
import router from '@/router'
import jwtDefaultConfig from './jwtDefaultConfig'
import { getDeviceInfo } from '@/helpers/getDeviceInfo'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Get User Device Information
    getDeviceInfo().then(result => {
      const previousDeviceInfo = JSON.parse(localStorage.getItem('deviceInfo'))

      // Check if there are changes
      if (JSON.stringify(result) !== JSON.stringify(previousDeviceInfo)) {
        localStorage.setItem('deviceInfo', JSON.stringify(result))
      }
    }).catch(error => {
      console.log(error)
    })

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()
        const refreshToken = this.getRefreshToken()
        const originalRequest = config

        const { currentRoute } = router

        // Set IP Address & Device Name from localStorage
        const deviceInfo = JSON.parse(localStorage.getItem('deviceInfo'))
        config.headers['Device-Ip-Address'] = deviceInfo.ipAddress
        config.headers['Device-Type'] = deviceInfo.deviceType
        config.headers['source-route'] = currentRoute.path || ''

        // Get language from localStorage
        const lang = localStorage.getItem('language') || 'en'
        const language = (lang === 'en') ? 'en-GB' : 'fr-FR'

        // Set the Accept-Language header
        config.headers['Accept-Language'] = language

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // check if token has not expired
          // debugger
          if (checkTokenExpiry(accessToken)) {
            // check if refresh token has not expired
            if (!checkTokenExpiry(refreshToken)) {
              // get refresh token
              if (!this.isAlreadyFetchingAccessToken) {
                this.isAlreadyFetchingAccessToken = true
                this.refreshToken().then(r => {
                  this.isAlreadyFetchingAccessToken = false

                  // Update accessToken in localStorage
                  this.setToken(r.data.accessToken)
                  this.setRefreshToken(r.data.refreshToken)

                  this.onAccessTokenFetched(r.data.accessToken)
                })
              }
              const retryOriginalRequest = new Promise(resolve => {
                this.addSubscriber(token => {
                  // Change Authorization header
                  originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${token}`
                  resolve(this.axiosIns(originalRequest))
                })
              })
              return retryOriginalRequest
            }
            // log user out
            localStorage.clear()
            sessionStorage.clear()
            store.dispatch('auth/updateSessionState', true)
            store.dispatch('auth/updateMessage', 'Please log in again to continue. Your current session has expired due to Inactivity.')
            store.dispatch('auth/logout')

            router.push({ name: 'auth-login' })
          } else {
            const permission = this.getUserPermission()
            config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
            config.headers.accesstoken = accessToken
            config.headers.usercomponent = this.encryptHeader(permission)
          }
        }
        if (!accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.usercomponent = `''|''|${window.location.href}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(response => {
      const { currentRoute } = router
      if (response && response.status === 202) {
        const excludedRoutes = ['pfi-onboarding-add', 'pfi-onboarding-edit']

        if (!excludedRoutes.includes(currentRoute.name)) {
          Vue.swal({
            text: response.data.Message,
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
          })
          router.push({ name: 'approvals-request' })
        }
      }
      return response
    }, error => {
      // const { config, response: { status } } = error
      const { response } = error
      // if (status === 401) {
      // if ((response && response.status === 403)) {
      //   Vue.swal({
      //     text: 'Kindly refresh page',
      //     icon: 'warning',
      //     customClass: {
      //       confirmButton: 'btn btn-primary',
      //     },
      //   })
      //   // this.$store.dispatch('auth/updateSessionState', true)
      //   // this.$store.dispatch('auth/logout')
      //   // router.push({ name: 'auth-login' })
      // }
      if ((response && response.status === 401)) {
        console.log('error status', response.status)
        // router.push({ name: 'misc-not-authorized' })
        // store.dispatch('auth/updateSessionState', true)
        // store.dispatch('auth/updateMessage', 'You were logged out because your session had expired. Kindly login again to continue')
        // router.push({ name: 'auth-login' })
      }
      if ((response && response.status === 417)) {
        store.dispatch('auth/updateSessionState', true)
        store.dispatch('auth/updateMessage', 'You were logged out either because your session had expired, or your password was changed. Kindly login again to continue')
        router.push({ name: 'auth-login' })
      }
      if ((response && response.status === 419)) {
        store.dispatch('auth/updateSessionState', true)
        store.dispatch('auth/updateMessage', 'You were logged out because the system detected your profile was active in more than one session. If this wasn’t you, please change your password immediately')
        router.push({ name: 'auth-login' })
      }
      // if ((response === undefined)) {
      // router.push({ name: 'misc-not-authorized' }).catch()
      // Vue.swal({
      //   text: 'You do not have right to view this page',
      //   icon: 'error',
      //   customClass: {
      //     confirmButton: 'btn btn-primary',
      //   },
      // })
      // return Promise.reject(response)
      // }
      return Promise.reject(error)
    })
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  getEmail() {
    return localStorage.getItem(this.jwtConfig.storageUserEmail)
  }

  getUserPermission() {
    return sessionStorage.getItem(this.jwtConfig.storageUserPermission)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  setEmail(value) {
    localStorage.setItem(this.jwtConfig.storageUserEmail, value)
  }

  setPermission(value) {
    sessionStorage.setItem(this.jwtConfig.storageUserPermission, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }

  encryptHeader(permission) {
    const url = window.location.href
    const userName = this.getEmail()
    return `${userName}|${permission}|${url}`
  }

  checkTokenExpiration() {
    const token = this.getToken()
    if (token && checkTokenValidity(token)) {
      return false
    }
    return true
  }

  checkRefreshTokenExpiration() {
    const refreshToken = this.getRefreshToken()
    if (refreshToken && checkTokenValidity(refreshToken)) {
      return false
    }
    return true
  }
}
